module.exports = __webpack_public_path__ + "static/media/logo_only.6a926f52.svg";